const ENV = window.ENV || process.env;
export default ENV;
